<div class="modal-header">
  <h4 class="modal-title"> {{'printLabelingPopup.title' | translate}}
    <a class="link ps-2" href="javascript:void(0)" data-gatm="global.label.help" (click)="openHELPLink()" tooltip [tooltipText]="'global.label.help' | translate"><app-svg-icon type="information_circle" [inline]="true"/></a>
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <div>
      <span [hidden]="!isLabelMaterialSelectionAvailable">{{ 'printLabelingPopup.message.info' | translate }} </span>
      <span [innerHTML]="'printLabelingPopup.message.info_link_for_download' | translate"></span>
    </div>
    <div class="form-check form-check-inline me-5 pe-5">
    <!-- smartscript version radio buttons -->
    <ng-container>
      <div class="mt-3 mb-1" [innerHTML]="'<b>' + ('printLabelingPopup.message.smartscript_version' | translate) + '</b>'"></div>
      <div class="form-check form-check-inline me-5 pr-5">
        <input name="versionSelection" type="radio" class="form-check-input" id="smartScriptVersion3" [value]="smartScriptVersions[0]" [(ngModel)]="smartScriptVersion">
        <label class="form-check-label" for="smartScriptVersion3">{{'printLabelingPopup.message.smart_script' | translate: { '0': smartScriptVersions[0] } }}</label>
      </div>
      <div class="form-check form-check-inline me-5 pr-5">
        <input name="versionSelection" type="radio" class="form-check-input" id="smartScriptVersion4" [value]="smartScriptVersions[1]" [(ngModel)]="smartScriptVersion">
        <label class="form-check-label" for="smartScriptVersion4">{{'printLabelingPopup.message.smart_script' | translate: { '0': smartScriptVersions[1] } }}</label>
      </div>
    </ng-container>
    <!-- cutmarks selection radio buttons -->
    <ng-container>
      <div class="mt-3 mb-1" [innerHTML]="'<b>' + ('printLabelingPopup.message.cutmarks' | translate) + '</b>'"></div>
      <div class="form-check form-check-inline me-5">
        <input (click)="selectNoCutmarks()" name="cutmarkSelection" type="radio" class="form-check-input" id="cutmarkNone" [value]="CUTMARK_NONE" [(ngModel)]="selectedCutmarkOption">
        <label class="form-check-label" for="cutmarkNone">{{'printLabelingPopup.radiobutton.nocutmark' | translate }}</label>
      </div>
      <div class="form-check form-check-inline me-5">
        <input (click)="selectStartCutmark()" name="cutmarkSelection" type="radio" class="form-check-input" id="cutmarkStart" [value]="CUTMARK_START" [(ngModel)]="selectedCutmarkOption">
        <label class="form-check-label" for="cutmarkStart">{{'printLabelingPopup.radiobutton.atstart' | translate }}</label>
      </div>
      <div class="form-check form-check-inline me-5">
        <input (click)="selectSectionCutmarks()" name="cutmarkSelection" type="radio" class="form-check-input" id="cutmarkSection" [value]="CUTMARK_SECTION" [(ngModel)]="selectedCutmarkOption">
        <label class="form-check-label" for="cutmarkSection">{{'printLabelingPopup.radiobutton.aftersection' | translate }}</label>
      </div>
    </ng-container>
    <div class="mt-3 mb-1" [hidden]="!isLabelMaterialSelectionAvailable" [innerHTML]="'<b>' + ('printLabelingPopup.message.material_selection' | translate) + '</b>'"></div>
      <div class="wrapper-scroll-y" [style.max-height.px]="200">
        <table  *ngIf="labelingArticleInfos.length !== 0" class="table table-hover table-sm aside-article-list m-0">
          <tbody>
            <tr>
              <th class="border-0"></th>
              <th class="border-0"></th>
              <th class="border-0">{{ 'printLabelingPopup.table.title.markingmaterials' | translate }}</th>
              <th class="border-0">{{ 'printLabelingPopup.table.title.cutmarks' | translate}}</th>
            </tr>
          <ng-template ngFor let-labelingArticleInfo [ngForOf]="labelingArticleInfos" let-i="index">
            <tr>
              <div *ngIf="labelingArticleInfo.children; then materialAndChildren else materialWithoutChildren"></div>
              <ng-template #materialAndChildren>
                <td width="15"></td>
                <td colspan="2" class="middle">
                  <i class="middle printlabeling" [class.has-accessory]="labelingArticleInfo.children"
                    [class.open]="openArticleRows.indexOf(i+1) !== -1" (click)="toggleArticleRow(i+1); $event.stopPropagation()">
                  </i>
                  <div class="form-check checkbox">
                  <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="{{2*i}}" (change)="toggleParentAndChildrenIsSelected(labelingArticleInfo)"
                    [checked]="labelingArticleInfo.isSelected">
                  <label class="form-check-label" for="{{2*i}}">
                    <span>{{ labelingArticleInfo.label }}</span>
                    <span class="smart-font">{{ labelingArticleInfo.labelForSubNodes }}</span>
                  </label>
                  </div>
                </td>
                <td>
                <div *ngIf="labelingArticleInfo.hasCutmarkAbility && isStartCutmarkOption(labelingArticleInfo)">
                  <i class="mdi mdi-check"></i>
                </div>
                <div *ngIf="!labelingArticleInfo.hasCutmarkAbility && !isNoCutmarkOption()">
                  <i class="mdi mdi-minus"></i>
                </div>
                </td>
              </ng-template>
              <ng-template #materialWithoutChildren>
                <td width="15"></td>
                <td colspan="2" class="middle">
                  <div class="form-check checkbox">
                  <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="{{2*i}}" (change)="toggleParentNoChildrenIsSelected(labelingArticleInfo)" [checked]="labelingArticleInfo.isSelected">
                  <label class="form-check-label" for="{{2*i}}">
                    <span>{{ labelingArticleInfo.label }}</span>
                    <span class="smart-font">{{ labelingArticleInfo.labelForSubNodes }}</span>
                  </label>
                  </div>
                </td>
                <td>
                  <div *ngIf="labelingArticleInfo.hasCutmarkAbility && isStartCutmarkOption(labelingArticleInfo)">
                    <i class="mdi mdi-check"></i>
                  </div>
                  <div *ngIf="!labelingArticleInfo.hasCutmarkAbility && !isNoCutmarkOption()">
                    <i class="mdi mdi-minus"></i>
                  </div>
                </td>
              </ng-template>
              </tr>
              <ng-template ngFor let-x [ngForOf]="labelingArticleInfo.children" let-xi="index">
                <tr [hidden]="openArticleRows.indexOf(i+1) === -1">
                  <td width="15"></td>
                  <td width="20"></td>
                  <td class="middle">
                    <div class="form-check checkbox">
                    <input class="form-check-input ng-untouched ng-pristine ng-valid" type="checkbox" id="{{x.articleUsageIds}}" [(ngModel)]="x.isSelected" (change)="onMaterialSelectionChange(labelingArticleInfo)">
                    <label class="form-check-label" for="{{x.articleUsageIds}}">
                      <span>{{ x.label }}</span>
                      <span class="smart-font">{{ x.labelForSubNodes }}</span>
                    </label>
                    </div>
                  </td>
                  <td>
                    <div *ngIf="labelingArticleInfo.hasCutmarkAbility && isSectionCutmarkOption()">
                      <i class="mdi mdi-check"></i>
                    </div>
                  </td>
                </tr>
                <tr [hidden]="openArticleRows.indexOf(i+1) === -1" *ngFor="let z of x.children; let zi = index">
                  <td width="15"></td>
                  <td width="20"></td>
                  <td class="middle">
                    <span>{{ z.label }}</span><span class="smart-font">{{ z.labelForSubNodes }}</span>
                  </td>
                </tr>
            </ng-template>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-secondary btn-forward" (click)="saveButtonClick()" [hidden]="!isSaveOperationAvailable" [disabled]="labelingArticleInfos.length === 0 || getSelectedItems().length === 0">
    {{'printLabelingPopup.button.save' | translate}}
  </button>
  <button class="btn btn-primary btn-forward" (click)="printButtonClick()" [disabled]="(!smartScriptVersion) || labelingArticleInfos.length === 0 || getSelectedItems().length === 0">
    {{'printLabelingPopup.button.print' | translate}}
  </button>
</div>
